import React from "react";
import { BROWN, PINK_LADY } from "../../../../constants/style/colors";
import EntityLink from "../../../shared/EntityLink";
import * as S from "../../style";

function DriverCell({ driver, entityLinkOptions }) {
    return driver && driver.id ? (
        <EntityLink
            entity={driver}
            options={entityLinkOptions}
        />
    ) : (
        <S.StyledBadge
            textColor={BROWN}
            borderColor={BROWN}
            color={PINK_LADY}
        >
            <span>No driver assigned</span>
        </S.StyledBadge>
    );
}

export default DriverCell;
